import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

// Import file CSS riêng
import './PageHeader.css';

/**
 * Component hiển thị Breadcrumbs và Tiêu đề trang với nền full-width.
 * @param {Array} breadcrumbs - Mảng các đối tượng breadcrumb.
 * @param {string} pageTitle - Tiêu đề chính của trang.
 * @param {boolean} showDisclaimer - Có hiển thị hộp thông báo hay không.
 */
const PageHeader = ({ breadcrumbs, pageTitle, showDisclaimer = false }) => {
    // Không render gì cả nếu không có breadcrumbs, hoặc chỉ có 1 breadcrumb (trang chủ)
    if (!breadcrumbs || breadcrumbs.length <= 1) {
        return null;
    }

    return (
        <div className="page-header-container">
            <div className="container">
                <div className="page-header-content-wrapper">
                    <div className="breadcrumbs">
                        {breadcrumbs.map((crumb, index) => (
                            <span key={crumb.ID || index}>
                                {index < breadcrumbs.length - 1 ? (
                                    <Link to={crumb.Url}>{crumb.Title}</Link>
                                ) : (
                                    <span>{crumb.Title}</span>
                                )}
                                {index < breadcrumbs.length - 1 && ' \u00bb '}
                            </span>
                        ))}
                    </div>

                    {pageTitle && (
                        <h1 className="page-title">{pageTitle}</h1>
                    )}

                    {showDisclaimer && (
                        <div className="disclaimer-box">
                            <i className="fa-solid fa-circle-info"></i>
                            <span>Thông tin xác thực phục vụ tra cứu; không được sử dụng cho mục đích khác</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// PropTypes để đảm bảo truyền đúng dữ liệu
PageHeader.propTypes = {
    breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
        ID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        Title: PropTypes.string.isRequired,
        Url: PropTypes.string.isRequired,
    })),
    pageTitle: PropTypes.string,
    showDisclaimer: PropTypes.bool,
};

export default PageHeader;